import React from "react";
import { SearchWrapper } from "./DashboardSearchBarStyle";
import Magnifier from "assets/icons/Magnifier.svg";
import { useNavigate } from "react-router-dom";

const DashboardSearchBar = () => {
  let navigate = useNavigate();
  const handleClick = () => {
    navigate("/dashboard/search");
  };

  // store -> middleware로 요청한다
  // state 담고
  // 아래에 state에서 list꺼내서 쭉 부려주기

  // lodash -> debounce, throttle 하면 좋고..
  // useEffect(() => {},[text]) 다른 페이지로
  // const [text,setText] = useState() ref() <-
  return (
    <SearchWrapper onClick={handleClick}>
      <img src={Magnifier} alt="Search image" />
      <p> 꽃 품목 혹은 꽃 이름을 검색해 보세요.</p>
    </SearchWrapper>
  );
};

export default DashboardSearchBar;
